import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { StoreIcon } from "lucide-react";
import type { ReactNode } from "react";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

type Props = {
  footer?: ReactNode;
};

export function ExchangeCreditOption({ footer }: Props) {
  const t = useCustomText();
  return (
    <Label htmlFor="exchange-credit">
      <Option>
        <OptionIcon>
          <StoreIcon />
        </OptionIcon>
        <OptionTitle>{t("exchangeOptions.credit.title")}</OptionTitle>
        <OptionDescription>
          {t("exchangeOptions.credit.description")}
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="exchange-credit" id="exchange-credit" />
        </OptionAction>
        {footer}
      </Option>
    </Label>
  );
}
